module.exports = __webpack_public_path__ + "img/js-logo.dd60b11e.svg";